import { useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { Divider, Modal as MuiModal } from "@mui/material";
import { useEventListener } from "pages/Hooks/useEventListener";
import { TRIGGER_MODAL } from "pages/constants/EventKeys";
import { useTranslation } from "react-i18next";

const style = {
  position: "absolute" as "absolute",
  top: "40%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: {
    xs: "100%",
    sm: "100%",
    md: 500,
  },
  bgcolor: "background.paper",
  border: "1px solid #000",
  borderRadius: "10px",
  boxShadow: 24,
  p: 3,
  display: "grid",
  gap: 2,
};

export default function Modal() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);

  type ModalContent = {
    title: string;
    content: any;
    actions?: Array<{
      label: string;
      variant?: string;
      color?: string;
      action: Function;
    }>;
  };

  const [content, setContent] = useState<ModalContent>({} as ModalContent);

  useEventListener(TRIGGER_MODAL, (content: ModalContent) => {
    setContent(content);
    setOpen(true);
  });

  return (
    <div>
      <MuiModal open={open} onClose={handleClose}>
        <Box sx={style}>
          <Typography fontWeight="bold" fontSize={25} color="success">
            {t(`FEEDBACK.MODAL.${content.title}`)}
          </Typography>

          <Divider />

          {content.content}

          {content.actions && (
            <>
              <Divider />

              <Box
                sx={{ display: "flex", justifyContent: "space-around", mt: 1 }}
              >
                {content.actions.map((action: any, i: number) => (
                  <Button
                    key={i}
                    variant={action.variant || "outlined"}
                    color={action.color || "success"}
                    onClick={(e: any) => {
                      action.action(e);
                      handleClose();
                    }}
                  >
                    {t(`FORM.SUBMIT.${action.label}`)}
                  </Button>
                ))}
              </Box>
            </>
          )}
        </Box>
      </MuiModal>
    </div>
  );
}
